/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder when a blog article is loading.
 */

import ContentLoader from "react-content-loader";

export function BlogArticlePlaceholder() {
  return (
    <ContentLoader
      width={600}
      height={800}
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      uniqueKey="blog-article"
    >
      <rect x="14" y="38" rx="0" ry="0" width="17" height="10" />
      <rect x="46" y="42" rx="0" ry="0" width="37" height="6" />
      <rect x="96" y="38" rx="0" ry="0" width="92" height="8" />
      <rect x="478" y="37" rx="6" ry="6" width="52" height="16" />
      <rect x="12" y="62" rx="0" ry="0" width="35" height="6" />
      <rect x="13" y="78" rx="0" ry="0" width="193" height="21" />
      <rect x="13" y="211" rx="0" ry="0" width="154" height="16" />
      <rect x="325" y="182" rx="0" ry="0" width="204" height="105" />
      <rect x="417" y="288" rx="0" ry="0" width="17" height="7" />
      <rect x="12" y="450" rx="0" ry="0" width="141" height="14" />
      <rect x="15" y="319" rx="0" ry="0" width="320" height="10" />
      <rect x="32" y="344" rx="0" ry="0" width="268" height="7" />
      <circle cx="25" cy="348" r="5" />
      <rect x="32" y="361" rx="0" ry="0" width="310" height="7" />
      <circle cx="25" cy="365" r="5" />
      <rect x="31" y="398" rx="0" ry="0" width="488" height="7" />
      <circle cx="25" cy="401" r="5" />
      <rect x="32" y="382" rx="0" ry="0" width="400" height="7" />
      <circle cx="25" cy="384" r="5" />
      <rect x="34" y="429" rx="0" ry="0" width="400" height="7" />
      <circle cx="25" cy="432" r="5" />
      <rect x="30" y="411" rx="0" ry="0" width="310" height="7" />
      <rect x="14" y="113" rx="0" ry="0" width="480" height="8" />
      <rect x="14" y="126" rx="0" ry="0" width="480" height="8" />
      <rect x="14" y="138" rx="0" ry="0" width="480" height="8" />
      <rect x="15" y="154" rx="0" ry="0" width="480" height="8" />
      <rect x="13" y="239" rx="0" ry="0" width="276" height="7" />
      <rect x="13" y="251" rx="0" ry="0" width="276" height="7" />
      <rect x="13" y="263" rx="0" ry="0" width="276" height="7" />
      <rect x="14" y="473" rx="0" ry="0" width="508" height="8" />
      <rect x="15" y="486" rx="0" ry="0" width="508" height="8" />
      <rect x="14" y="498" rx="0" ry="0" width="508" height="8" />
      <rect x="15" y="513" rx="0" ry="0" width="508" height="8" />
      <rect x="14" y="526" rx="0" ry="0" width="508" height="8" />
      <rect x="14" y="541" rx="0" ry="0" width="165" height="9" />
      <rect x="30" y="568" rx="0" ry="0" width="488" height="7" />
      <circle cx="24" cy="571" r="5" />
      <rect x="29" y="581" rx="0" ry="0" width="310" height="7" />
      <rect x="30" y="596" rx="0" ry="0" width="488" height="7" />
      <circle cx="24" cy="599" r="5" />
      <rect x="29" y="620" rx="0" ry="0" width="310" height="7" />
      <rect x="30" y="643" rx="0" ry="0" width="488" height="7" />
      <circle cx="24" cy="646" r="5" />
      <rect x="29" y="656" rx="0" ry="0" width="310" height="7" />
      <rect x="29" y="609" rx="0" ry="0" width="488" height="7" />
      <rect x="14" y="680" rx="0" ry="0" width="508" height="8" />
      <rect x="15" y="693" rx="0" ry="0" width="508" height="8" />
      <rect x="14" y="719" rx="0" ry="0" width="65" height="8" />
      <rect x="13" y="748" rx="6" ry="6" width="49" height="17" />
      <rect x="18" y="776" rx="8" ry="8" width="57" height="20" />
      <rect x="81" y="775" rx="8" ry="8" width="57" height="20" />
      <rect x="142" y="775" rx="8" ry="8" width="57" height="20" />
      <rect x="201" y="775" rx="8" ry="8" width="57" height="20" />
      <rect x="262" y="775" rx="8" ry="8" width="57" height="20" />
    </ContentLoader>
  );
}
